import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import { sliceLast7 } from "./chart-data";
import { chartColors } from "./chart-colors";

/**
 * 配送件数推移 (折れ線). daily_trend を直近 7 日にスライスし、予定/完了の 2 本を描画する.
 */
export function DeliveryTrendChart({
  values,
}: {
  values: { date: string; total: number; completed: number }[];
}) {
  const data = sliceLast7(values);
  return (
    <div className="panel" style={{ padding: "18px 20px" }}>
      <div className="eyebrow" style={{ marginBottom: 4 }}>
        配送件数 推移
      </div>
      <div style={{ fontSize: 15, fontWeight: 500, marginBottom: 16 }}>直近7日</div>
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={data} margin={{ top: 4, right: 12, bottom: 4, left: -16 }}>
          <CartesianGrid strokeDasharray="3 3" stroke={chartColors.grid()} vertical={false} />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 10, fill: chartColors.axis() }}
            stroke={chartColors.grid()}
          />
          <YAxis
            allowDecimals={false}
            tick={{ fontSize: 10, fill: chartColors.axis() }}
            stroke={chartColors.grid()}
          />
          <Tooltip />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          <Line
            type="monotone"
            dataKey="total"
            name="予定"
            stroke={chartColors.planned()}
            strokeWidth={2}
            dot={false}
          />
          <Line
            type="monotone"
            dataKey="completed"
            name="完了"
            stroke={chartColors.completed()}
            strokeWidth={2}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
